import { useMedia } from 'react-use';

/**
 * Conveniant hook to avoid sticky hover effect.
 * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/hover
 * @returns true if the primary input mechanism can conveniently hover over elements.
 */
export const useHasMediaHover = () => useMedia('(hover: hover) and (pointer: fine)');
/* The pointer feature tests whether the device has a pointer here a mouse for example
    because some versions of Android have a feature where a long press emulates hover
*/
